import { useLang } from "../context/LangProvider";
import { useWords } from "../hooks";
import { Link } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import Select, { components } from "react-select";
import "./Navbar.css";
import { useState } from "react";

const { Option } = components;
const IconOption = (props) => (
  <Option {...props}>
    <div className="flex items-center">
      <img
        src={props.data.icon}
        alt={props.data.label}
        className="w-4 h-4 object-cover mr-2 rounded-full"
      />
      {props.data.label}
    </div>
  </Option>
);

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(null);
  const [lang, setLang] = useLang();
  const langWords = useWords(lang);
  const links = [
    { name: langWords.services, path: "/services" },
    { name: langWords.about, path: "/about" },
    { name: langWords.partners, path: "/partners" },
    { name: langWords.faq, path: "/faq" },
    { name: langWords.contactUs, path: "/contact-us" },
  ];
  const options = [
    {
      value: "fr",
      label: "Fr",
      icon: "https://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg",
    },
    {
      value: "en",
      label: "En",
      icon: "https://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg",
    },
  ];

  const customTheme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: "#6EE7B7",
      neutral15: "#00000000",
    },
  });

  return (
    <nav className="py-4 bg-secondary shadow fixed top-0 left-0 z-10 w-full">
      <div className="container flex justify-between items-center">
        <div>
          <Link to="/">
            <img className="w-32" src="/assets/logo-dark.png" alt="ADSILlogo" />
          </Link>
        </div>
        <div className="flex items-center">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="z-50 md:hidden mr-2"
          >
            {showMenu ? (
              <AiOutlineClose size="1.7rem" />
            ) : (
              <AiOutlineMenu size="1.7rem" />
            )}
          </button>
          <ul className="hidden md:block">
            {links.map((link) => (
              <li key={link.path} className="inline-block group">
                <Link
                  className="py-2 px-3 capitalize relative"
                  to={link.path}
                  onClick={() => setShowMenu(false)}
                >
                  {link.name}
                  <div className="absolute left-1/2 transform -translate-x-1/2">
                    <div className="text-transparent group-hover:text-primary animate-animated animate-heartBeat animate-infinite">
                      <IoIosArrowDown />
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
          <span className={`overlay ${showMenu ? "show" : "close"}`}></span>
          <div className={`linkParent ${showMenu ? "show" : "close"}`}>
            <ul className={`navlinks bg-secondary`}>
              <li>
                <img
                  src="/assets/logo-dark.png"
                  alt="adsil"
                  className="w-64 -mt-16"
                />
              </li>
              {links.map((link) => (
                <li key={link.path} className="link inline-block group">
                  <Link
                    className="py-2 px-3 capitalize relative"
                    to={link.path}
                    onClick={() => setShowMenu(false)}
                  >
                    {link.name}
                    <div className="absolute left-1/2 transform -translate-x-1/2">
                      <div className="text-transparent group-hover:text-primary animate-animated animate-heartBeat animate-infinite">
                        <IoIosArrowDown />
                      </div>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <Select
            onChange={(value) => setLang(value.value)}
            defaultValue={options.find((option) => option.value === lang)}
            options={options}
            theme={customTheme}
            isSearchable={false}
            components={{ Option: IconOption }}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
